module.exports = __webpack_public_path__ + "img/banner.94a238a0.png";